module.exports = __webpack_public_path__ + "img/bottle_with_popping_cork.672026ca.gif";